<template>
    <div class="WordSection1" style='word-wrap:break-word'>
        <img width=256px src="images/newsbanner.png">
        <h2>&nbsp;</h2>
        <h2><span style="color: #6f0000;"><strong>My.MARSILLI 2.0 </strong></span></h2>
        <h2><span style="color: #800000;"><strong><em>from now available! </em></strong></span></h2>
        <h2><em>Check the new features </em></h2>
        <p>&nbsp;</p>
        <p><strong><span style="background-color: #6f0000;">&nbsp; &nbsp;&nbsp;</span>&nbsp; SPARE PARTS MANAGEMENT </strong></p>
        <ol>
        <li>Collect all the spare part you need using &ldquo;Send to Cart&rdquo;. Find all the items on &ldquo;RFQ&rdquo; in &ldquo;Spare Parts Management&rdquo;, adjust the quantity and send your RFQ. It is saved to build the history of requests sent via My.Marsilli.</li>
        <li>Export the BoM in excel (even with filter applied!)</li>
        <li>Search by part code in all your Marsilli equipment using &ldquo;Full search by part&rdquo; in &ldquo;Spare Parts Management&rdquo;.</li>
        <li>Filter the spare parts orders by your order number.</li>
        <li>Have a look at the DDT or the invoice related to your spare parts order by clicking on the cells.</li>
        </ol>
        <p><strong><span style="background-color: #6f0000;">&nbsp; &nbsp; </span>&nbsp;&nbsp;REPAIRS OVERVIEW </strong></p>
        <ol>
        <li>The brand new &ldquo;Repairs&rdquo;! Click on &ldquo;repair code&rdquo; or &ldquo;service offer&rdquo; to have a look at the offer, check the status, ask for a repair.</li>
        </ol>
        <p><strong><span style="background-color: #6f0000;">&nbsp; &nbsp;&nbsp;</span>&nbsp;USERS MANAGEMENT </strong></p>
        <ol>
        <li>Multiple accounts for different locations? Switch among them by clicking on your name, avoiding log-out and re-enter each time.</li>
        <li>Create other &ldquo;master&rdquo; user if a colleague needs to manage a team. If you instead don&rsquo;t want him to send RFQ or open a ticket, then select &ldquo;yes&rdquo; in the row &ldquo;read only&rdquo;.</li>
        </ol>
        <p><strong><span style="background-color: #6f0000;">&nbsp; &nbsp;&nbsp;</span>&nbsp;CALENDAR </strong></p>
        <ol>
        <li>Check the closing days of our locations in the calendar: visit &ldquo;Support&rdquo;!.</li>
        </ol>
    </div>
</template>
<script>
// import { API } from "@/api.js";
export default {
    name: "NewRelease",
    data() {
        return {};
    },
    async mounted() { },
    computed: {
        logged() {
            console.log("logged app", this.$store.getters.userId);
            return !!this.$store.getters.userId;
        },
        // privacyOK() {
        // 	let pok = this.$store.getters.privacyOK;
        // 	console.log("privacyOK?", pok);
        // 	return pok;
        // },
    },
    methods: {
        // setPrivacy() {
        // 	// posso solo settarla
        // 	API.setPrivacy(1);
        // 	this.$store.commit("privacyOK", null);
        // },
    },
};
</script>
<style>
/* Font Definitions */
@font-face {
    font-family: "Cambria Math";
    panose-1: 2 4 5 3 5 4 6 3 2 4;
}

@font-face {
    font-family: DengXian;
    panose-1: 2 1 6 0 3 1 1 1 1 1;
}

@font-face {
    font-family: Aptos;
}

@font-face {
    font-family: RotisSemiSerifStd;
    panose-1: 0 0 0 0 0 0 0 0 0 0;
}

@font-face {
    font-family: "\@DengXian";
    panose-1: 2 1 6 0 3 1 1 1 1 1;
}

/* Style Definitions */
p.MsoNormal,
li.MsoNormal,
div.MsoNormal {
    margin: 0cm;
    font-size: 12.0pt;
    font-family: "Aptos", sans-serif;
}

p.MsoListParagraph,
li.MsoListParagraph,
div.MsoListParagraph {
    margin-top: 0cm;
    margin-right: 0cm;
    margin-bottom: 0cm;
    margin-left: 36.0pt;
    font-size: 12.0pt;
    font-family: "Aptos", sans-serif;
}

p.MsoListParagraphCxSpFirst,
li.MsoListParagraphCxSpFirst,
div.MsoListParagraphCxSpFirst {
    margin-top: 0cm;
    margin-right: 0cm;
    margin-bottom: 0cm;
    margin-left: 36.0pt;
    font-size: 12.0pt;
    font-family: "Aptos", sans-serif;
}

p.MsoListParagraphCxSpMiddle,
li.MsoListParagraphCxSpMiddle,
div.MsoListParagraphCxSpMiddle {
    margin-top: 0cm;
    margin-right: 0cm;
    margin-bottom: 0cm;
    margin-left: 36.0pt;
    font-size: 12.0pt;
    font-family: "Aptos", sans-serif;
}

p.MsoListParagraphCxSpLast,
li.MsoListParagraphCxSpLast,
div.MsoListParagraphCxSpLast {
    margin-top: 0cm;
    margin-right: 0cm;
    margin-bottom: 0cm;
    margin-left: 36.0pt;
    font-size: 12.0pt;
    font-family: "Aptos", sans-serif;
}

.MsoChpDefault {
    font-size: 12.0pt;
}

@page WordSection1 {
    size: 595.3pt 841.9pt;
    margin: 70.85pt 2.0cm 2.0cm 2.0cm;
}

div.WordSection1 {
    page: WordSection1;
}

/* List Definitions */
ol {
    margin-bottom: 0cm;
}

ul {
    margin-bottom: 0cm;
}
</style>